import { HBox } from "../../../../common/components/HBox";
import { PlayerModel } from "../../../../common/models/PlayerModel";
import { CommonResourcesPackage } from "../../../../common/resources/CommonResourcesPackage";
import { BoosterType } from "../../../../common/models/data/BoosterType";
import { BoosterButton } from "./BoosterButton";
import { Event } from "event-system";
import { Container, IDestroyOptions, Point, Rectangle } from "pixi.js";
import { VBox } from "../../../../common/components/VBox";
import { nameof } from "bindable-data";

type Orientation = "vertical" | "horizontal";

export class BoostersPanel extends Container {
    public readonly onBoosterClick: Event<BoosterType, boolean>;

    private readonly boosters: Map<BoosterType, BoosterButton>;

    private box: Container;

    public constructor(commonResources: CommonResourcesPackage, private readonly playerModel: PlayerModel) {
        super();
        this.eventMode = "static";
        this.box = this.addChild(new HBox(20));
        this.onBoosterClick = new Event();
        this.boosters = new Map();
        for (const [type, info] of playerModel.boosters) {
            const [count, _usageCount, level] = info;
            const button = new BoosterButton(commonResources, type, count, level, true);
            button.onUp.add(this.onBoosterClickHandler, this);
            this.boosters.set(type, button);
            this.box.addChild(button);
        }
        this.hitArea = new Rectangle(0, 0, this.width, this.height);
        this.playerModel.propertyChanged.add(this.onPlayerPropertyChange, this);
    }

    public getFlyTargetCoordinates(type: BoosterType): Point {
        const boosterButton = this.boosters.get(type);
        return boosterButton.flyTargetCoordinates;
    }

    public changeOrientation(orientation: Orientation): void {
        let box: Container;
        switch (orientation) {
            case "horizontal":
                if (this.box instanceof HBox) {
                    return;
                }
                box = new HBox(20);
                break;
            case "vertical":
                if (this.box instanceof VBox) {
                    return;
                }
                box = new VBox(20);
                break;
        }

        for (const child of Object.assign([], this.box.children.reverse())) {
            child.position.set(0);
            box.addChild(child);
        }
        this.removeChild(this.box);
        this.box.destroy({ baseTexture: false, children: true, texture: false });
        this.box = this.addChild(box);
        this.updateHitArea();
    }

    private onBoosterClickHandler(button: BoosterButton): void {
        this.onBoosterClick.emit(button.type, button.isAdRefill);
    }

    public onPlayerPropertyChange(model: PlayerModel, key: string): void {
        if (key === nameof(model, "boosters")) {
            for (const [type, info] of model.boosters) {
                const [count, _usageCount, level] = info;
                const button = this.boosters.get(type);
                button.count = count;
                button.level = level;
            }
        }
    }

    private updateHitArea(padding: number = 20): void {
        const bounds = this.getLocalBounds();
        this.hitArea = new Rectangle(bounds.x - padding, bounds.y - padding, bounds.width + padding * 2, bounds.height + padding * 2);
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.playerModel.propertyChanged.remove(this.onPlayerPropertyChange, this);
        for (const [_type, button] of this.boosters) {
            button.onUp.remove(this.onBoosterClickHandler, this);
        }
        super.destroy(options);
    }
}
